import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a88730a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "right_content" }
const _hoisted_3 = { class: "mod_wrap mod_set_wrap" }
const _hoisted_4 = { class: "mod_c_title flex between" }
const _hoisted_5 = { class: "content_top flex between" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "photo_btn" }
const _hoisted_8 = { class: "mod_nav_btn_title" }
const _hoisted_9 = {
  key: 1,
  class: "list_null"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "img_box" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "live_title" }
const _hoisted_14 = { class: "top flex between" }
const _hoisted_15 = { class: "icons flex between" }
const _hoisted_16 = { class: "img_box" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "item_right" }
const _hoisted_19 = { class: "flex between" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_color" }, "分类：", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_color" }, "类型：", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "span_color" }, "时间：", -1))
const _hoisted_23 = { class: "icons" }
const _hoisted_24 = { class: "pagination" }
const _hoisted_25 = { class: "flex between search_top" }
const _hoisted_26 = { class: "flex left" }
const _hoisted_27 = { class: "select" }
const _hoisted_28 = { class: "primary" }
const _hoisted_29 = { class: "content_square modal_item" }
const _hoisted_30 = { class: "modal_pagination" }

import { computed, reactive, ref, defineAsyncComponent, watch, unref } from 'vue';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';
import { RightOutlined, SearchOutlined } from '@ant-design/icons-vue';
import { DatePicker, Input, Pagination, Modal, message } from 'ant-design-vue';
import { useStore } from 'vuex';
import LiveItemSquare from '@/components/liveItem/LiveItemSquare.vue';
import { useDebounce } from '@/hooks/useDebounce';
import { useRoute } from 'vue-router';
import { VueDraggableNext } from 'vue-draggable-next';
import { ranges, queryForm, pageConfig, modalPageConfig, RootLive } from './dataJson';
import { moveSort, createSort } from './sortFunction';
import http from '@/api/conentCenter/communal';
import CAddCategoryVue from '../components/CAddCategory.vue';
import CMove from '../components/CMoveSort.vue';
import Crumb from '@/components/Crumb.vue';
import CMenu from '../components/CLeftMenu.vue';
import CLoading from '@/components/CLoading.vue';
import CDelModal from '@/components/CDelModal.vue';
import emitter from '@/utils/mitt';
import { dragDrop } from '@/utils/format/dragDrop';


export default /*#__PURE__*/_defineComponent({
  __name: 'liveClassify',
  setup(__props) {

const draggable = VueDraggableNext;
const route = useRoute();
const gatewayId = route.params.gatewayId;
const LiveTab = defineAsyncComponent(() => import('@/components/liveItem/LiveTab.vue'));
const store = useStore();
const aInputSearch = Input.Search;
const aPagination = Pagination;
const aRangePicker = DatePicker.RangePicker;
const aModal = Modal;

const cutoverView = ref(true); // 视图切换按钮
const getCutoverIcon = computed(() => {
  return cutoverView.value ? 'list' : 'block';
});
const getCutoverName = computed(() => {
  return cutoverView.value ? '列表视图' : '缩略视图';
});
const switchView = () => {
  cutoverView.value = !cutoverView.value;
};

// 拖拽
const dragOptions = {
  animation: 0,
  group: 'description',
  disabled: false,
  ghostClass: 'ghost',
};

/**
 * 添加直播间
 */

const modalChecked = ref<boolean>(false);
const modalSelected = ref<boolean>(false);
const modalLiveList = ref<RootLive[]>([]);

const modalQueryForm = reactive({
  keywords: '',
});
const modalLiveInfo = ref({
  live_studio_count: 0,
});
const selectKeys = ref({});
const changeItemMark = (item: RootLive) => {
  selectKeys.value[item.id] = !selectKeys.value[item.id];
};
const isChecked = computed(() => {
  return modalChecked.value || modalSelected.value;
});
const changeSwitch = () => {
  if (modalChecked.value === false) {
    Object.keys(selectKeys.value).forEach((k) => {
      selectKeys.value[k] = true;
    });
  } else {
    Object.keys(selectKeys.value).forEach((k) => {
      selectKeys.value[k] = false;
    });
  }
};
const changeItemMarkAll = () => {
  if (modalSelected.value === true) {
    Object.keys(selectKeys.value).forEach((k) => {
      selectKeys.value[k] = true;
    });
  } else {
    Object.keys(selectKeys.value).forEach((k) => {
      selectKeys.value[k] = false;
    });
  }
};

const getSelectIds = computed(() => {
  const selectArr = Array<any>();
  Object.keys(selectKeys.value).forEach((e) => {
    if (selectKeys.value[e] === true) {
      selectArr.push(e);
    }
  });
  return selectArr.join(',');
});

const getModalLiveList = useDebounce(async () => {
  try {
    const { current, pageSize } = modalPageConfig;
    const search = {
      page: current,
      page_num: pageSize,
      ...modalQueryForm,
    };
    const { data, live_studio_count, total } = await store.dispatch('live/getLiveList', search);
    modalLiveList.value = data;
    modalLiveInfo.value.live_studio_count = live_studio_count;
    modalPageConfig.totalSize = total;
    selectKeys.value = {};
    data.map((e: RootLive) => {
      selectKeys.value[e.id] = false;
    });
    clear();
  } catch (err: any) {
    console.error(err.data.error);
  }
});

const clear = () => {
  queryForm.checked_all = false;
  studioIds.value = [];
  modalSelected.value = false;
};
// 取消添加直播
const closeAdd = () => {
  sortSelectKeys.value = [];
  selectKeys.value = {};
  modalChecked.value = false;
  clear();
};
// 确认添加直播
const handleOkAdd = () => {
  if (!getSelectIds.value) {
    queryForm.addLiveVisible = false;
    return;
  } else {
    queryForm.addLiveVisible = false;
  }
  let params = {
    studio_id: getSelectIds.value,
    sort_id: sortId.value,
    portal_id: gatewayId,
  };
  createStatus.value = 0;
  http
    .add_portal_live(params)
    .then((res) => {
      if (res.data.code == 200) {
        sortSelectKeys.value = [];
        selectKeys.value = {};
        modalChecked.value = false;
        clear();
        getPortalLiveList(1);
        createStatus.value = 3;
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};

/** */

/**
 * 添加分类
 */
const { isVisible, createStatus, getCreate } = createSort({
  gatewayId: gatewayId,
});

const addCategory = () => {
  isVisible.value = true;
};
const isopenDelModal = () => {
  isVisible.value = !isVisible.value;
};
/** */

// 分类id
const sortId = ref();
const sortInfo = ref();
const getSortInfo = (data: any) => {
  sortId.value = data.id;
  sortInfo.value = data;
  getPortalLiveList(1);
};
const liveList = ref<RootLive[]>([]);
const showLoading = ref<boolean>(false);
const sortSelectKeys = ref({});
const studioIds: any = ref([]);

// 获取直播分类直播列表
const getPortalLiveList = (current: number) => {
  showLoading.value = true;
  sortSelectKeys.value = {};
  clear();
  let params = {
    keywords: queryForm.keywords,
    start_at: queryForm.liveDate[0],
    end_at: queryForm.liveDate[1],
    sort_id: sortId.value,
    page: current,
    page_num: pageConfig.pageSize,
    portal_id: gatewayId,
  };
  http
    .get_portal_live_list({ params })
    .then((res) => {
      pageConfig.totalSize = res.data.data.total;
      liveList.value = res.data.data.data;
      liveList.value.map((e: RootLive) => {
        sortSelectKeys.value[e.id] = false;
        e['isEdit'] = false;
      });
      showLoading.value = false;
    })
    .catch(() => {
      showLoading.value = false;
    });
};

const changeCheckAll = () => {
  if (queryForm.checked_all === true) {
    Object.keys(sortSelectKeys.value).forEach((k) => {
      sortSelectKeys.value[k] = true;
    });
  } else {
    Object.keys(sortSelectKeys.value).forEach((k) => {
      sortSelectKeys.value[k] = false;
    });
  }
  changeSelctPortalLive(0);
};

// 删除弹窗
const openDelModal = () => {
  queryForm.modalVisible = true;
};
const closeDelModal = () => {
  queryForm.modalVisible = !queryForm.modalVisible;
  sortSelectKeys.value = [];
  clear();
};
// 删除确定按钮
const removeLiveData = () => {
  let params = {
    studio_id: studioIds.value.join(','),
    portal_id: gatewayId,
  };
  createStatus.value = 0;
  http
    .del_portal_live({ params })
    .then((res) => {
      message.success(res.data.message);
      queryForm.modalVisible = false;
      getPortalLiveList(1);
      createStatus.value = 3;
    })
    .catch((res) => {
      message.error(res.data.message);
      queryForm.modalVisible = false;
    });
};

const changeSelctPortalLive = (id: any) => {
  let arr = Object.keys(sortSelectKeys.value).filter((e) => sortSelectKeys.value[e] == true);
  id ? (queryForm.modalVisible = true) : '';
  id ? studioIds.value.push(id) : (studioIds.value = arr);
  emitSelectedRowKeys();
};
const editTitle = ref();
const clickEdit = (item: any) => {
  item.isEdit = !item.isEdit;
  item.isEdit ? editTitle.value.blur() : setStudioTitle(item);
};

const setStudioTitle = (item: any) => {
  let params = {
    studio_id: item.id,
    title: item.title,
    portal_id: gatewayId,
  };
  http
    .set_studio_title(params)
    .then((res) => {
      message.success(res.data.message);
      item.isEdit = false;
    })
    .catch((res) => {
      message.error(res.data.message);
      item.isEdit = false;
    });
};
const jumpWatch = (item: any) => {
  window.open(item.qr_code_url, '_blank');
};

// 根据header项过滤菜单
const selectedKeys = ref<string[]>([]);
/**
 * init 初始化
 * 路由进入前处理底部栏
 **/
store.commit('home/setCustomFooter', true);
const customData = computed(() => store.state.home.customData);
const customFootStyle = computed(() => store.state.home.customFootStyle);
onBeforeRouteUpdate((to) => {
  selectedKeys.value = [to.path];
});
onBeforeRouteLeave(() => {
  store.commit('home/setCustomFooter', false);
});

const moveSortId = ref();
const getMoveSortId = (data: any) => {
  moveSortId.value = data;
};
/**
 * 移动分类
 */
const emitSelectedRowKeys = () => {
  let arr = Object.keys(sortSelectKeys.value).filter((e) => sortSelectKeys.value[e] == true);
  emitter.emit('selectedRowKeys', arr);
};

const childRef = ref();
const { isMove, moveStatus, createMove } = moveSort({
  type: 3,
  gatewayId: gatewayId,
});
watch(
  () => moveStatus.value,
  () => {
    moveStatus.value == 3 && getPortalLiveList(1);
  }
);

const moveCategory = () => {
  isMove.value = true;
};
const closeMove = () => {
  isMove.value = !isMove.value;
};

/** */

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CMenu, {
        "data-source": { menuType: 3, createSort: _unref(createStatus), moveSort: _unref(moveStatus) },
        onSortInfo: getSortInfo
      }, null, 8, ["data-source"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createTextVNode(" 直播分类 / "),
              _withDirectives(_createElementVNode("span", { class: "sub_title" }, _toDisplayString(sortInfo.value?.name) + "(" + _toDisplayString(sortInfo.value?.count) + ")", 513), [
                [_vShow, sortInfo.value?.name]
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_a_button, { onClick: moveCategory }, {
                default: _withCtx(() => [
                  _createTextVNode("移至分类"),
                  _createVNode(_unref(RightOutlined))
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                class: "mod_btn_primary actived",
                onClick: addCategory
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加分类")
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(aRangePicker), {
                class: "mod_range_picker",
                value: _unref(queryForm).liveDate,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(queryForm).liveDate) = $event)),
                "show-time": { format: 'HH:mm' },
                format: "YYYY-MM-DD HH:mm",
                ranges: _unref(ranges),
                onOk: _cache[1] || (_cache[1] = ($event: any) => (getPortalLiveList(1))),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (getPortalLiveList(1)))
              }, {
                suffixIcon: _withCtx(() => [
                  _createVNode(_component_svg_icon, { "icon-class": "icon_time" })
                ]),
                _: 1
              }, 8, ["value", "ranges"]),
              _createVNode(_unref(aInputSearch), {
                class: "mod_range_picker_search",
                value: _unref(queryForm).keywords,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(queryForm).keywords) = $event)),
                placeholder: "请输入标题名称",
                onSearch: _cache[4] || (_cache[4] = ($event: any) => (getPortalLiveList(1)))
              }, {
                enterButton: _withCtx(() => [
                  _createVNode(_unref(SearchOutlined))
                ]),
                _: 1
              }, 8, ["value"]),
              _createVNode(_component_a_button, {
                type: "primary",
                class: "add_btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(getModalLiveList)(), (_unref(queryForm).addLiveVisible = true)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: switchView
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "btn_icon",
                    "icon-class": _unref(getCutoverIcon)
                  }, null, 8, ["icon-class"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(getCutoverName)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_checkbox, {
                checked: _unref(queryForm).checked_all,
                "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_unref(queryForm).checked_all) = $event)),
                onChange: _cache[7] || (_cache[7] = ($event: any) => (changeCheckAll())),
                class: "cache_check"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("全选")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_component_a_button, {
                class: "mod_btn",
                type: "link",
                danger: "",
                disabled: studioIds.value.length == 0,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (openDelModal()))
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_svg_icon, {
                    class: "mod_btn_icon",
                    "icon-class": "del"
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" 删除 ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          (showLoading.value)
            ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
            : (liveList.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_svg_icon, { "icon-class": "content_live_listnull" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createVNode(_unref(draggable), _mergeProps({
                      handle: ".mover",
                      class: "content_bottom flex between content_square",
                      list: liveList.value
                    }, dragOptions, {
                      disabled: liveList.value.length < 1,
                      onDrop: _unref(dragDrop)
                    }), {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveList.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "list_item",
                            key: item.id
                          }, [
                            _createElementVNode("div", {
                              class: "hover_top flex between",
                              style: _normalizeStyle(sortSelectKeys.value[item.id] ? 'display:block' : '')
                            }, [
                              _createVNode(_component_a_checkbox, {
                                class: "select",
                                checked: sortSelectKeys.value[item.id],
                                "onUpdate:checked": ($event: any) => ((sortSelectKeys.value[item.id]) = $event),
                                onChange: _cache[9] || (_cache[9] = ($event: any) => (changeSelctPortalLive('')))
                              }, null, 8, ["checked", "onUpdate:checked"]),
                              _withDirectives(_createVNode(_component_svg_icon, {
                                class: "mover",
                                "icon-class": "drag_icon"
                              }, null, 512), [
                                [_vShow, liveList.value.length > 1]
                              ])
                            ], 4),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("img", {
                                src: item.image_player_cover_url,
                                alt: ""
                              }, null, 8, _hoisted_12)
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _withDirectives(_createElementVNode("p", null, _toDisplayString(item.title), 513), [
                                  [_vShow, !item.isEdit]
                                ]),
                                _withDirectives(_createVNode(_component_a_input, {
                                  class: "edit_input",
                                  ref_for: true,
                                  ref_key: "editTitle",
                                  ref: editTitle,
                                  value: item.title,
                                  "onUpdate:value": ($event: any) => ((item.title) = $event),
                                  onBlur: ($event: any) => (setStudioTitle(item)),
                                  onPressEnter: ($event: any) => (setStudioTitle(item))
                                }, null, 8, ["value", "onUpdate:value", "onBlur", "onPressEnter"]), [
                                  [_vShow, item.isEdit]
                                ]),
                                _createVNode(_unref(LiveTab), {
                                  tabType: "status",
                                  statusType: item.status,
                                  size: "sm"
                                }, null, 8, ["statusType"])
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("p", null, [
                                  _createVNode(_component_svg_icon, {
                                    "icon-class": "content_live_edit",
                                    class: "icon_edit cursor",
                                    style: _normalizeStyle(item.isEdit ? 'color:#01a2e9' : ''),
                                    onClick: ($event: any) => (clickEdit(item))
                                  }, null, 8, ["style", "onClick"]),
                                  _createVNode(_component_svg_icon, {
                                    "icon-class": "content_live_video",
                                    class: "icon_video cursor",
                                    onClick: ($event: any) => (jumpWatch(item))
                                  }, null, 8, ["onClick"])
                                ]),
                                _createVNode(_component_svg_icon, {
                                  "icon-class": "content_live_del",
                                  class: "icon_del cursor",
                                  onClick: ($event: any) => (!_unref(queryForm).checked_all ? changeSelctPortalLive(item.id) : '')
                                }, null, 8, ["onClick"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 16, ["list", "disabled", "onDrop"]), [
                      [_vShow, cutoverView.value]
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveList.value, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "flex list_item_two",
                        key: item.id
                      }, [
                        _createVNode(_component_a_checkbox, {
                          class: "select",
                          checked: sortSelectKeys.value[item.id],
                          "onUpdate:checked": ($event: any) => ((sortSelectKeys.value[item.id]) = $event),
                          onChange: _cache[10] || (_cache[10] = ($event: any) => (changeSelctPortalLive('')))
                        }, null, 8, ["checked", "onUpdate:checked"]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("img", {
                            src: item.image_player_cover_url,
                            alt: ""
                          }, null, 8, _hoisted_17)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _withDirectives(_createElementVNode("p", { class: "ellipsis" }, _toDisplayString(item.title), 513), [
                            [_vShow, !item.isEdit]
                          ]),
                          _withDirectives(_createVNode(_component_a_input, {
                            class: "edit_input",
                            ref_for: true,
                            ref_key: "editTitle",
                            ref: editTitle,
                            value: item.title,
                            "onUpdate:value": ($event: any) => ((item.title) = $event),
                            onBlur: ($event: any) => (setStudioTitle(item)),
                            onPressEnter: ($event: any) => (setStudioTitle(item))
                          }, null, 8, ["value", "onUpdate:value", "onBlur", "onPressEnter"]), [
                            [_vShow, item.isEdit]
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("p", null, [
                              _hoisted_20,
                              _createTextVNode(_toDisplayString(item.sort_name), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _hoisted_21,
                              _createTextVNode(_toDisplayString(item.mode_title), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _hoisted_22,
                              _createTextVNode(_toDisplayString(item.start_at), 1)
                            ]),
                            _createElementVNode("p", _hoisted_23, [
                              _createVNode(_component_svg_icon, {
                                "icon-class": "content_live_edit",
                                class: "icon_edit cursor",
                                style: _normalizeStyle(item.isEdit ? 'color:#01a2e9' : ''),
                                onClick: ($event: any) => (clickEdit(item))
                              }, null, 8, ["style", "onClick"]),
                              _createVNode(_component_svg_icon, {
                                "icon-class": "content_live_video",
                                class: "icon_video cursor",
                                onClick: ($event: any) => (jumpWatch(item))
                              }, null, 8, ["onClick"]),
                              _createVNode(_component_svg_icon, {
                                "icon-class": "content_live_del",
                                class: "icon_del cursor",
                                onClick: ($event: any) => (!_unref(queryForm).checked_all ? changeSelctPortalLive(item.id) : '')
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ], 512), [
                    [_vShow, !cutoverView.value]
                  ])
                ])),
          _createElementVNode("div", _hoisted_24, [
            (liveList.value.length !== 0)
              ? (_openBlock(), _createBlock(_unref(aPagination), {
                  key: 0,
                  total: _unref(pageConfig).totalSize,
                  current: _unref(pageConfig).current,
                  "onUpdate:current": _cache[11] || (_cache[11] = ($event: any) => ((_unref(pageConfig).current) = $event)),
                  "page-size": _unref(pageConfig).pageSize,
                  "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((_unref(pageConfig).pageSize) = $event)),
                  pageSizeOptions: _unref(pageConfig).options,
                  "show-less-items": "",
                  "show-size-changer": "",
                  "show-quick-jumper": "",
                  onChange: _cache[13] || (_cache[13] = ($event: any) => (getPortalLiveList(_unref(pageConfig).current))),
                  onShowSizeChange: _cache[14] || (_cache[14] = ($event: any) => (getPortalLiveList(_unref(pageConfig).current)))
                }, null, 8, ["total", "current", "page-size", "pageSizeOptions"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(CDelModal, {
            visible: _unref(queryForm).modalVisible,
            centered: "",
            close: closeDelModal,
            ok: removeLiveData
          }, null, 8, ["visible"]),
          _createVNode(_unref(aModal), {
            centered: "",
            width: "1238px",
            visible: _unref(queryForm).addLiveVisible,
            "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((_unref(queryForm).addLiveVisible) = $event)),
            title: "添加直播",
            onOk: handleOkAdd,
            okText: "确定",
            onCancel: closeAdd
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(aInputSearch), {
                    class: "mod_range_picker_search",
                    style: {"margin":"0"},
                    value: modalQueryForm.keywords,
                    "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((modalQueryForm.keywords) = $event)),
                    placeholder: "搜索直播间标题",
                    onSearch: _cache[16] || (_cache[16] = ($event: any) => (_unref(getModalLiveList)()))
                  }, {
                    enterButton: _withCtx(() => [
                      _createVNode(_unref(SearchOutlined))
                    ]),
                    _: 1
                  }, 8, ["value"]),
                  _createElementVNode("div", _hoisted_27, [
                    _createTextVNode(" 直播间："),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(modalLiveInfo.value.live_studio_count), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_a_checkbox, {
                    class: "select",
                    checked: modalChecked.value,
                    "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((modalChecked).value = $event)),
                    onChange: _cache[18] || (_cache[18] = ($event: any) => (changeSwitch()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("选择")
                    ]),
                    _: 1
                  }, 8, ["checked"]),
                  _createVNode(_component_a_checkbox, {
                    class: "select",
                    checked: modalSelected.value,
                    "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((modalSelected).value = $event)),
                    onChange: _cache[20] || (_cache[20] = ($event: any) => (changeItemMarkAll()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("全选")
                    ]),
                    _: 1
                  }, 8, ["checked"])
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modalLiveList.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    _createVNode(LiveItemSquare, {
                      "data-source": item,
                      choice: _unref(isChecked),
                      selected: selectKeys.value[item.id],
                      "onSelect:changeItemMark": changeItemMark
                    }, null, 8, ["data-source", "choice", "selected"])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_unref(aPagination), {
                  total: _unref(modalPageConfig).totalSize,
                  current: _unref(modalPageConfig).current,
                  "onUpdate:current": _cache[21] || (_cache[21] = ($event: any) => ((_unref(modalPageConfig).current) = $event)),
                  "page-size": _unref(modalPageConfig).pageSize,
                  "onUpdate:pageSize": _cache[22] || (_cache[22] = ($event: any) => ((_unref(modalPageConfig).pageSize) = $event)),
                  pageSizeOptions: _unref(modalPageConfig).options,
                  "show-less-items": "",
                  "show-size-changer": "",
                  "show-quick-jumper": "",
                  onChange: _cache[23] || (_cache[23] = ($event: any) => (_unref(getModalLiveList)())),
                  onShowSizeChange: _cache[24] || (_cache[24] = ($event: any) => (_unref(getModalLiveList)()))
                }, null, 8, ["total", "current", "page-size", "pageSizeOptions"])
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(CAddCategoryVue, {
            menuType: 3,
            visible: _unref(isVisible),
            close: isopenDelModal,
            ok: _unref(getCreate),
            centered: ""
          }, null, 8, ["visible", "ok"]),
          _createVNode(CMove, {
            ref_key: "childRef",
            ref: childRef,
            "data-source": { menuType: 3, moveStatus: _unref(moveStatus) },
            visible: _unref(isMove),
            close: closeMove,
            ok: _unref(createMove),
            onMoveSortId: getMoveSortId,
            centered: "",
            onSortInfo: getSortInfo
          }, null, 8, ["data-source", "visible", "ok"])
        ]),
        _withDirectives(_createElementVNode("div", { class: "mod_footer" }, _toDisplayString(_unref(customData).copyright), 513), [
          [_vShow, _unref(customFootStyle)]
        ])
      ])
    ])
  ], 64))
}
}

})